<template>
  <div class="page" v-if="event">
    <div v-if="tag" :class="tag.Codice">
      <h1 class="title title--page [ mb-0 ]">
        {{ tag.Descrizione }} <br />
        <app-category :color="tag.Colore"></app-category>
      </h1>
    </div>

    <div class="row mx-0" v-if="event">
      <div class="col-12 col-lg-5 [ px-0 ]">
        <img
          v-if="event && event.immagine && event.immagine != ''"
          :src="getImageUrl(event.immagine)"
          class="img-fluid img-fit"
          alt=""
        />
      </div>
      <div class="col-12 col-lg-7 [ px-0 ]">
        <div v-if="event" class="container">
          <div class="row [ border-bottom ] [ py-3 ]">
            <div class="col-12">
              <div class="d-flex align-items-center"
                   v-if="
                   event && event.eventoLuoghi && event.eventoLuoghi.length>
                0
                "
                >
                <div class="pr-1 svg"
                     v-if="
                     event && event.eventoLuoghi && event.eventoLuoghi.length>
                  0
                  "
                  >
                  <app-marker v-if="tag" :color="tag.Colore"></app-marker>
                </div>
                <div v-if="
                     event && event.eventoLuoghi && event.eventoLuoghi.length>
                  0
                  "
                  >
                  <p class="text-size-12 text-weight-600 [ text-uppercase ] [ mb-0 ]">
                    {{ event.eventoLuoghi[0].Descrizione }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h1 class="subtitle subtitle--detail [ pt-4 ]">
            {{ event.titolo }}
            <span v-if="event && event.esaurito"
                  class="text-size-12 badge badge-primary">SOLD OUT</span>
          </h1>

          <div class="d-flex">
            <div class="pr-2">
              <img src="../../assets/ico-calendar.svg" alt="" />
            </div>
            <div>
              <p class="text-size-10 text-weight-700 line-height-1 [ text-uppercase ]">
                Da {{ event.inizio | formatDate }}<br />
                a {{ event.fine | formatDate }}
              </p>
            </div>
          </div>

          <div v-html="event.descrizione"
               class="text-size-12 text-weight-500 [ pb-4 ]"></div>

          <div v-if="event.tiporegistrazione == 99">
            <div v-if="event"
                 class="text-center p-4">
              <em>
                Accesso libero/ Non richiede prenotazione
              </em>
            </div>
          </div>
          <div v-if="event.tiporegistrazione != 99">
            <div v-if="event && !event.esaurito && event.pre"
                 class="text-center p-4">
              <em>
                Le prenotazioni si apriranno il
                {{ event.inizioPrenotazione | formatEventDate }}
              </em>
            </div>
 
            <div v-if="event && !event.esaurito && event.post && event.sessioni.filter(x=>x.prenotabile).length==0"
                 class="text-center p-4">
              <em>
                Prenotazioni chiuse il
                {{ event.finePrenotazione | formatEventDate }}
              </em>
            </div>
            <div v-if="event && event.esaurito" class="text-center p-4">
              <em>SOLD OUT</em>
            </div>
            <div v-if="
              event &&
              event.prenotabile &&
              (!event.esaurito || (event.esaurito && event.state != 0))
            "
                 class="form__wrapper">
              <h3 class="text-center text-size-18 text-weight-600" :class='{ " [ pb-3 ]": event.sessioni.length > 1 }''>
                
                PRENOTA  
              </h3>
              <h4 class="text-center text-size-12 text-weight-600 [ pb-3 ]" v-if="event && event.sessioni && event.sessioni.length ==1 "> {{  event.sessioni[0].inizio | formatSessionDate }}</h4>
              <form @submit.prevent="attemptRegister">
                <div class="form-group"
                     v-if="event && event.sessioni && event.sessioni.length > 1">
                  <select v-model="event.id"
                          name="eventId"
                          class="form-control"
                          v-if="event && event.sessioni && event.sessioni.length > 1"
                          v-on:change="setEventData">
                    <option :value="null">Seleziona una data</option>
                    <option v-if="event && event.sessioni && event.sessioni.length > 1"
                            v-for="s in event.sessioni"
                            :key="index"
                            :value="s.id"
                            :disabled="s.esaurito && s.state == 0">
                      {{ s.inizio | formatSessionDate }}
                    </option>
                  </select>
                </div>

                <div class="form-group" v-if="event.id">
                  <input type="text"
                         v-model="prenotazione.email"
                         name="email"
                         class="form-control"
                         placeholder="Indirizzo Email"
                         data-vv-as="email"
                         v-validate="'required|email'"
                         :class="errors.has('email') ? 'is-invalid' : ''"
                         @change="refreshPosti" />
                  <small class="form-text text-danger">
                    {{
                  errors.first("email")
                    }}
                  </small>
                </div>
                <div class="form-group"
                     v-if="
                  event &&
                  event.id
                ">
                  <input type="text"
                         v-model="prenotazione.nome"
                         name="nome"
                         class="form-control"
                         placeholder="Nome"
                         data-vv-as="nome"
                         v-validate="{ required: true, regex: /([^0-9]*){2,}$/ }"
                         :class="errors.has('nome') ? 'is-invalid' : ''" />
                  <small class="form-text text-danger">
                    {{
                  errors.first("nome")
                    }}
                  </small>
                </div>
                <div class="form-group"
                     v-if="
                  event &&
                  event.id
                ">
                  <input type="text"
                         v-model="prenotazione.cognome"
                         class="form-control"
                         name="cognome"
                         placeholder="Cognome"
                         data-vv-as="cognome"
                         v-validate="{ required: true, regex: /([^0-9]*){2,}$/ }"
                         :class="errors.has('cognome') ? 'is-invalid' : ''" />
                  <small class="form-text text-danger">
                    {{
                  errors.first("cognome")
                    }}
                  </small>
                </div>
                <div class="form-group" v-if="event.id">
                  <input type="text"
                         v-model="prenotazione.numerotelefono"
                         name="telefono"
                         class="form-control"
                         placeholder="Telefono"
                         data-vv-as="telefono"
                         v-validate="'required'"
                         :class="errors.has('telefono') ? 'is-invalid' : ''" />
                  <small class="form-text text-danger">
                    {{
                  errors.first("telefono")
                    }}
                  </small>
                </div>

                <div class="form-group" v-if="event.id">
                  <select v-model="prenotazione.numeroposti"
                          name="posti"
                          class="form-control"
                          data-vv-as="posti"
                          v-validate="'required'"
                          :class="errors.has('posti') ? 'is-invalid' : ''">
                    <option value="">Numero di posti</option>
                    <option v-for="index in event.massimoprenotazioni"
                            :key="index"
                            :value="index">
                      {{ index }}
                    </option>
                  </select>
                </div>

                <div v-for="(m, i) in prenotazione.membri"
                     v-if="event.tiporegistrazione >= 1 && event.id">
                  <div class="form-group"
                       v-if="i + 1 <= prenotazione.numeroposti">
                    <h4>Partecipante {{ i + 1 }}</h4>
                  </div>

                  <div class="form-group"
                       v-if="i + 1 <= prenotazione.numeroposti">
                    <input type="text"
                           v-model="m.Nome"
                           class="form-control"
                           :name="'Nome Partecipante ' + (i + 1)"
                           placeholder="Nome"
                           :data-vv-as="'Nome Partecipante ' + (i + 1)"
                           v-validate="{ required: true, regex: /([^0-9]*){2,}$/ }"
                           :class="
                      errors.has('Nome Partecipante ' + (i + 1))
                        ? 'is-invalid'
                        : ''
                    " />
                    <small class="form-text text-danger">
                      {{
                    errors.first("Nome Partecipante " + (i + 1))
                      }}
                    </small>
                  </div>
                  <div class="form-group"
                       v-if="i + 1 <= prenotazione.numeroposti">
                    <input type="text"
                           v-model="m.Cognome"
                           class="form-control"
                           placeholder="Cognome"
                           :data-vv-as="'Cognome Partecipante ' + (i + 1)"
                           :name="'Cognome Partecipante ' + (i + 1)"
                           v-validate="{ required: true, regex: /([^0-9]*){2,}$/ }"
                           :class="
                      errors.has('Cognome Partecipante ' + (i + 1))
                        ? 'is-invalid'
                        : ''
                    " />
                    <small class="form-text text-danger">
                      {{
                    errors.first("Cognome Partecipante " + (i + 1))
                      }}
                    </small>
                  </div>

                  <div class="form-group"
                       v-if="i + 1 <= prenotazione.numeroposti">
                    <label v-if="event.tiporegistrazione == 2">
                      Provenienza <i>(es. Parma, Milano)</i>
                    </label>
                    <label v-if="event.tiporegistrazione < 2">Luogo e data di nascita</label>

                    <input v-if="event.tiporegistrazione < 2"
                           type="text"
                           v-model="m.LuogoNascita"
                           :name="'Luogo di nascita Partecipante ' + (i + 1)"
                           class="form-control"
                           placeholder="Luogo di nascita"
                           :data-vv-as="'Luogo di nascita Partecipante ' + (i + 1)"
                           v-validate="{ required: true }"
                           :class="
                      errors.has('Luogo di nascita Partecipante ' + (i + 1))
                        ? 'is-invalid'
                        : ''
                    " />
                    <input v-if="event.tiporegistrazione == 2"
                           type="text"
                           v-model="m.LuogoNascita"
                           class="form-control"
                           :name="'Provenienza Partecipante ' + (i + 1)"
                           placeholder="Provenienza"
                           :data-vv-as="'Provenienza Partecipante ' + (i + 1)"
                           v-validate="{ required: true }"
                           :class="
                      errors.has('Provenienza Partecipante ' + (i + 1))
                        ? 'is-invalid'
                        : ''
                    " />
                    <small class="form-text text-danger">
                      {{
                    errors.first("Provenienza Partecipante " + (i + 1))
                      }}
                    </small>
                  </div>
                  <div class="form-group"
                       v-if="
                       i + 1 <= prenotazione.numeroposti &&
                    event.tiporegistrazione == 1
                  "
                >
                  <input
                    type="date"
                    v-model="m.DataNascita"
                    class="form-control"
                    placeholder="Data di nascita"
                    data-vv-as="datanascita"
                    v-validate="{ required: true }"
                    :class="errors.has('datanascita') ? 'is-invalid' : ''"
                  />
                  <small class="form-text text-danger">{{
                    errors.first("datanascita")
                  }}</small>
                </div>

                  <div class="form-group"
                       v-if="
                       i + 1 <= prenotazione.numeroposti &&
                    event.tiporegistrazione == 1 &&
                    i > 0
                  "
                >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="'convivente' + i"
                      v-model="m.Convivente"
                    />
                    <label class="custom-control-label" :for="'convivente' + i"
                      >Convivente
                      <em
                        ><small
                          >(SELEZIONARE SOLO SE IL POSTO PRENOTATO &Egrave; PER
                          PERSONA CONVIVENTE CON IL
                          <strong>PARTECIPANTE 1</strong> DELLA PRESENTE
                          PRENOTAZIONE)</small
                        ></em
                      ></label
                    >
                  </div>
                </div>
                </div>

                <div class="form-group" v-if="event.id">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           v-validate="'required|alpha'"
                           id="privacy"
                           name="privacy"
                           :class="errors.has('privacy') ? 'is-invalid' : ''" />
                    <label class="custom-control-label" for="privacy">
                      Dichiaro di aver letto
                      <a href="https://www.comune.parma.it/it/informazioni-generali/privacy-policy"
                         target="_blank"
                         class="text-primary">
                        l'INFORMATIVA per il trattamento dei dati personali ai
                        sensi dell'art 13 del Regolamento europeo n. 679/2016
                      </a>
                      e acconsento al loro trattamento
                    </label>
                  </div>
                  <small class="form-text text-danger">
                    {{
                  errors.first("privacy")
                    }}
                  </small>
                </div>

                <div class="form-group [ text-center ]" v-if="event.id">
                  <button v-if="event && event.prenotabile && !event.esaurito"
                          type="submit"
                          class="btn btn-primary btn-block"
                          :disabled="event.massimoprenotazioni == 0 || sending">
                    Prenota ora
                  </button>

                  <button v-if="
                    event &&
                    event.prenotabile &&
                    event.esaurito &&
                    event.state != 0
                  "
                          type="submit"
                          class="btn btn-primary btn-block"
                          :disabled="event.massimoprenotazioni == 0 || sending">
                    Entra in lista d'attesa
                  </button>
                </div>

                <div class="alert alert-danger [ text-center ]"
                     v-if="errormessage != ''">
                  {{ errormessage }}
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>
    </div>
  </div>
</template>
<style>
option:disabled {
  color: rgb(128, 128, 128);
  opacity: 0.3;
}
</style>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapActions } from 'vuex'
import { event } from '../../_store/event.module'

moment.locale('it')

export default {
  data () {
    return {
      errormessage: '',
      loaded: false,
      sending: false,
      prenotazione: {
        id: '',
        nome: '',
        cognome: '',
        email: '',
        numerotelefono: '',
        numeroposti: '',
        posti: 0,
        membri: []
      }
    }
  },
  components: {},
  mounted () {
    this.$store.state.event.event = null
    var me = this
    if (!me.$route.params.slug || me.$route.params.slug == '') {
      this.router.push('/')
    }
    // this.$store.dispatch('event/event', { slug: me.$route.params.slug || 'all', q: '', start: '', end: '' }).then(function () {
    //  if (me.event.sessioni.length > 1) {
    //    me.$store.state.event.event.id = null;
    //  }
    //  else if (me.event.sessioni.length == 1) {
    //    console.log("me.event.sessioni.length", me.event.sessioni);
    //    me.$store.state.event.event.id = me.event.sessioni[0].id;
    //    setTimeout(me.setEventData, 1000);
    //  }

    // }
    // );
  },
  computed: {
    event () {
      // this.$store.dispatch('course/courses', { start: this.$store.state.course.selectedWeek.start, end: this.$store.state.course.selectedWeek.end, level: this.$store.state.course.selectedLevel.courseLevelId } );
      var me = this

      if (!this.$store.state.event.event) {
        this.$store
          .dispatch('event/event', {
            slug: me.$route.params.slug || 'all',
            q: '',
            start: '',
            end: ''
          })
          .then(function () {})
      }
      if (
        !me.loaded &&
        this.$store.state.event.event &&
        this.$store.state.event.event.sessioni
      ) {
        if (this.$store.state.event.event.sessioni.length > 1) {
          me.$store.state.event.event.id = null
        } else if (this.$store.state.event.event.sessioni.length == 1) {
          this.$store.state.event.event.id =
            this.$store.state.event.event.sessioni[0].id
          setTimeout(me.setEventData, 100)
        }
        this.loaded = true
      }
      return this.$store.state.event.event
    },
    tag () {
      if (this.event && this.$store.state.event && this.event.eventoTags) {
        for (var i = 0; i < this.event.eventoTags.length; i++) {
          for (var j = 0; j < this.$store.state.event.tags.length; j++) {
            if (
              this.$store.state.event.tags[j].Codice ==
              this.event.eventoTags[i].Codice
            ) {
              return this.$store.state.event.tags[j]
            }
          }
        }
      }
    }
  },
  methods: {
    isValidNominativo (value) {
      return !/([^0-9]*){2,}$/.test(value)
    },
    setEventData () {
      for (var i = 0; i < this.event.sessioni.length; i++) {
        var s = this.event.sessioni[i]
        if (this.event.id == s.id) {
          this.event.prenotabile = s.prenotabile
          this.event.state = s.state
          this.event.esaurito = s.esaurito
          this.event.tiporegistrazione = s.tiporegistrazione
          this.prenotazione.id = ''
          this.prenotazione.nome = ''
          this.prenotazione.cognome = ''
          this.prenotazione.email = ''
          this.prenotazione.numerotelefono = ''
          this.prenotazione.numeroposti = ''
          this.prenotazione.posti = 0
          this.prenotazione.membri = []

          break
        }
      }
      this.refreshPosti()
    },
    refreshPosti () {
      this.prenotazione.id = this.event.id
      this.errormessage = ''
      this.event.massimoprenotazioni = 0
      this.$store.dispatch('event/maxposti', this.prenotazione).then(
        (s) => {
          if (s.error) {
            this.errormessage = s.message
            this.event.massimoprenotazioni = 0
          } else {
            this.event.massimoprenotazioni = s.data

            if (
              this.$store.state.event.event &&
              this.prenotazione.membri.length == 0
            ) {
              for (
                var i = 0;
                i < this.$store.state.event.event.massimoprenotazioni;
                i++
              ) {
                this.prenotazione.membri.push({
                  Nome: '',
                  Cognome: '',
                  DataNascita: null,
                  LuogoNascita: ''
                })
                this.prenotazione.numeroposti = ''
              }
            }
          }
        },
        (error) => {
          dispatch(
            'message/enrollment',
            {
              enroll: null,
              success: false,
              message: error.message,
              userEnroll: enroll
            },
            { root: true }
          )
        }
      )
    },
    attemptRegister () {
      var me = this

      this.$validator.validateAll().then((isValid) => {
        if (!isValid || this.sending) return
        this.sending = true
        this.prenotazione.id = this.event.id

        /* if (event.tiporegistrazione == 1) {
          this.prenotazione.nome = this.prenotazione.membri[0].nome;
          this.prenotazione.cognome = this.prenotazione.membri[0].cognome;
        } */

        this.prenotazione.lista = this.event.esaurito && this.event.state != 0

        this.prenotazione.posti = isNaN(
          parseInt(this.prenotazione.numeroposti.toString())
        )
          ? 0
          : parseInt(this.prenotazione.numeroposti.toString())

        if (
          me.event &&
          me.event.prenotabile &&
          me.event.esaurito &&
          me.event.state != 0
        ) {
          me.$store.dispatch('event/enrollment', {
            enroll: me.prenotazione,
            vm: me
          })
        } else {
          me.$swal({
            icon: 'info',
            text: "Si ricorda di annullare la prenotazione in caso disdetta della partecipazione all'evento.",
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              me.$store.dispatch('event/enrollment', {
                enroll: me.prenotazione,
                vm: me
              })
            } else {
              me.sending = false
            }
          })
        }
      })
    },
    getImageUrl (image) {
      return window.base_image_url + image + '?width=600'
    }
  },
  beforeRouteUpdate (to, from, next) {
    var me = this
    // react to route changes...
    // this.$store.dispatch('event/clearEvents');
    // don't forget to call next()
    next()
  },
  created () {
    var me = this
  }
}
</script>
